import { Link, useLocation } from "react-router-dom";
import { CartIcon, FileIcon, PersonIcon } from '../../../components/icons';

const TABS = [
  { key: "proposal", label: "提案", path: "/proposal", icon: FileIcon },
  { key: "orders", label: "注文状況", path: "/orders", icon: CartIcon },
  { key: "profile", label: "プロフィール", path: "/profile", icon: PersonIcon },
]

export const BottomNav = () => {
  const location = useLocation();
  const currentTab = TABS.find((tab) => location.pathname.startsWith(tab.path));

  return (
    <div
      style={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 1000 }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          backgroundColor: "#fff",
          borderTop: "1px solid #e8e8e8",
          padding: "8px 0",
        }}
      >
        {TABS.map((tab) => {
          const Icon = tab.icon
          const isActive = currentTab?.key === tab.key
          return (<Link
            key={tab.key}
            to={tab.path}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textDecoration: "none",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <Icon color={isActive ? "#1890ff" : "#000"} />
              <span style={{ fontSize: 12, color: isActive ? "#1890ff" : "#000" }}>{tab.label}</span>
            </div>
          </Link>);
        })}
      </div>
    </div>
  );
};
